import { Spin } from 'antd'
import React from 'react'

function Spinner(props) {
  return (
    <div className="spinner-container">
<Spin  size={"large"}/>

</div>

  )
}

export default Spinner